import { reducer as form } from 'redux-form';

import model from './modules/model';
import websocket from './modules/websocket';
import user from './modules/user';
import floors from './modules/model/floors';
import evacReplay from '@/redux/new_store_structure/reducers/evacReplay';
import notifications from '@/redux/new_store_structure/reducers/notifications';
import sites from '@/redux/new_store_structure/reducers/sites';
import holders from '@/redux/new_store_structure/reducers/holders';
import visits from '@/redux/new_store_structure/reducers/visits';
import holderZoneReport from '@/redux/new_store_structure/reducers/holderZoneReport';
import holderAbsenceReport from '@/redux/new_store_structure/reducers/holderAbsenceReport';

export default {
	// Add reducers here
	model,
	websocket,
	form,
	user,
	floors,
	evacReplay,
	notifications,
	sites,
	holders,
	visits,
  holderZoneReport,
  holderAbsenceReport
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js